<form [formGroup]="historiqueForm">
    <mat-card>
        <h1 class="subtitle col-md-12">{{texteService.getTexte('TITLE_HISTORIQUE_1')}}</h1>
        <mat-card-content class="col-md-12">
            <div class="form-row d-flex align-self-center">
                <div class="col-md-6 form-row">
                    <label for="historique-taille" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_HISTORIQUE_TAILLE')}}<span
                            class="red-label">*</span></label>
                    <mat-form-field class="input-form col-md-7">
                        <input id="historique-taille" matInput type="number" name="taille" formControlName="taille" />
                        <mat-error
                            *ngIf="historiqueForm.controls.taille.touched && historiqueForm.controls.taille.hasError('required')">
                            {{texteService.getTexte('ERR_CHAMP_REQUIRED')}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 form-row">
                    <label for="historique-poid" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_HISTORIQUE_POID')}}<span
                            class="red-label">*</span></label>
                    <mat-form-field class="input-form col-md-7">
                        <input id="historique-poid" matInput type="number" name="poid" formControlName="poid" />
                        <mat-error
                            *ngIf="historiqueForm.controls.poid.touched && historiqueForm.controls.poid.hasError('required')">
                            {{texteService.getTexte('ERR_CHAMP_REQUIRED')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <span id="historique-conditions-label" class="form-label">{{texteService.getTexte('LABEL_HISTORIQUE_CONDITION')}}</span>
            <div class="row d-flex flex-wrap" role="group" aria-labelledby="historique-conditions-label">
                <div *ngFor="let condition of conditions" class="col-md-6">
                    <mat-checkbox (change)="onConditionsChanged($event, condition)">
                        {{texteService.getTexte(condition.codeTexte, condition.libelle)}}
                    </mat-checkbox>
                </div>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="historique-infection"
                    class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_HISTORIQUE_INFECTION')}}</label>
                <mat-form-field class="input-form col-md-7">
                    <input id="historique-infection" matInput type="text" name="infection" formControlName="infection" />
                </mat-form-field>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <h1 class="subtitle col-md-12">{{texteService.getTexte('TITLE_HISTORIQUE_2')}}</h1>
        <mat-card-content class="col-md-12">
            <div class="form-row d-flex align-self-center">
                <span id="historique-fume-label" class="col-md-5 align-self-center form-label">{{texteService.getTexte('LABEL_HISTORIQUE_FUME')}}<span
                        class="red-label">*</span></span>
                <div class="col-md-7">
                    <mat-radio-group name="fume" formControlName="fume" aria-labelledby="historique-fume-label">
                        <mat-radio-button value="true">
                            {{texteService.getTexte('LABEL_OUI')}}</mat-radio-button>
                        <mat-radio-button value="false">
                            {{texteService.getTexte('LABEL_NON')}}</mat-radio-button>
                    </mat-radio-group>
                    <mat-error
                        *ngIf="historiqueForm.controls.fume.touched && historiqueForm.controls.fume.hasError('required')">
                        {{texteService.getTexte('ERR_CHAMP_REQUIRED')}}</mat-error>
                </div>
            </div>

            <div class="form-row d-flex align-self-center">
                <span id="historique-alcool-label" class="col-md-5 align-self-center form-label">{{texteService.getTexte('LABEL_HISTORIQUE_ALCOOL')}}<span
                        class="red-label">*</span></span>
                <div class="col-md-7">
                    <mat-radio-group name="alcool" formControlName="alcool" aria-labelledby="historique-alcool-label">
                        <mat-radio-button value="true">
                            {{texteService.getTexte('LABEL_OUI')}}</mat-radio-button>
                        <mat-radio-button value="false">
                            {{texteService.getTexte('LABEL_NON')}}</mat-radio-button>
                    </mat-radio-group>
                    <mat-error
                        *ngIf="historiqueForm.controls.alcool.touched && historiqueForm.controls.alcool.hasError('required')">
                        {{texteService.getTexte('ERR_CHAMP_REQUIRED')}}</mat-error>
                </div>
            </div>
        </mat-card-content>

    </mat-card>

</form>
